import { IdentityDocumentTypeEnum } from '../../../enums/identity-document-type.enum';
import { FileDto } from '../../files/dtos/file.dto';

import { BaseSearchDto } from './base-search.dto';

export abstract class BaseDriverSearchDto extends BaseSearchDto {
  code!: string;
  driverId?: number | null;
  driverIdentityDocumentType?: IdentityDocumentTypeEnum | null;
  driverIdentityDocumentNumber?: string | null;
  driverIdentityDocumentExpiryDate?: Date | null;
  driverDrivingLicenseNumber?: string | null;
  driverDrivingLicenseCategory?: string | null;
  driverDrivingLicenseExpiryDate?: Date | null;
  files?: FileDto[] | null;
}
